module.exports = __webpack_public_path__ + "static/media/water.21988ef6.svg";